module.exports = __webpack_public_path__ + "media/images/guide/image8-d123ce4ac078325e4ced88771bdc849a.png";